export const OPEN_CRM_EVENT = "sigma-open-crm"
export const CRM_SETTINGS_CHANGED_EVENT = "sigma-crm-settings-changed"
export const CRM_STAGES_CHANGED_EVENT = "sigma-crm-stages-changed"
export const CRM_SESSIONS_CHANGED_EVENT = "sigma-crm-sessions-changed"
export const CRM_CONSULTATIONS_CHANGED_EVENT = "sigma-crm-consultations-changed"
export const CRM_TASKS_CHANGED_EVENT = "sigma-crm-tasks-changed"
export const CRM_TIMELINE_CHANGED_EVENT = "sigma-crm-timeline-changed"

export const openCrm = (recovery = false) => {
  window.dispatchEvent(new CustomEvent(OPEN_CRM_EVENT, { detail: { recovery } }))
}
